// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"b252c60b","4591":"3858cf53","4658":"58b3163d","5642":"58b3163d","6921":"6233a87d","7742":"674558ed","7744":"6cb4566e"}[chunkId] + ".chunk.css";
};